import React, { useRef, useState } from 'react';

import FeedbackCollector, { FeedbackFlag } from '@atlaskit/feedback-collector';
import { FlagGroup } from '@atlaskit/flag';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import { SurfaceMetadata } from '@atlassian/ai-smart-button-api';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { DynamicSurfaceActionItem } from '../action-item';

const FEEDBACK_ENTRYPOINT_ID = '9a6e0f65-eca3-4f73-8e40-5d4c466fee65';
const FEEDBACK_CONTEXT_NAME = 'ai-smart-button-ai-actions-feedback-collector';
const FEEDBACK_CONTEXT_CF = 'customfield_10047';

export const FeedbackActionItem = ({ surfaceMetadata }: { surfaceMetadata: SurfaceMetadata }) => {
	const ref = useRef<HTMLElement | null>(null);

	const [isOpen, setIsOpen] = useState(false);
	const [displayFlag, setDisplayFlag] = useState(false);

	const openFeedbackDialog = () => setIsOpen(true);
	const closeFeedbackDialog = () => setIsOpen(false);
	const displayFlagTrue = () => setDisplayFlag(true);
	const hideFlag = () => setDisplayFlag(false);

	const feedbackContext = {
		product: surfaceMetadata.product,
		pageMode: surfaceMetadata?.pageMode,
	};

	return (
		<>
			<DynamicSurfaceActionItem
				title="Give feedback"
				icon={<FeedbackIcon label="Feedback icon" />}
				status={undefined}
				isSelected={false}
				onClick={openFeedbackDialog}
			/>

			{isOpen && (
				<FeedbackCollector
					onClose={closeFeedbackDialog}
					entrypointId={FEEDBACK_ENTRYPOINT_ID}
					shouldReturnFocusRef={ref}
					name={FEEDBACK_CONTEXT_NAME}
					onSubmit={displayFlagTrue}
					additionalFields={[
						{
							id: FEEDBACK_CONTEXT_CF,
							value: feedbackContext,
						},
					]}
				/>
			)}

			<FlagGroup onDismissed={hideFlag}>{displayFlag && <FeedbackFlag />}</FlagGroup>
		</>
	);
};
